import { createTheme } from "@mui/material/styles";

const FormThemes = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        size: "small",
        margin: "dense",
        variant: "outlined",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Rounded corners for a softer look
          backgroundColor: "#f9f9f9", // Light gray background for contrast
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d3d3d3", // Softer default border
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#a0a0a0", // Darker border on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2DB0E4", // Brand-specific blue for focus
            boxShadow: "0 0 4px rgba(45,176,228,0.3)", // Subtle shadow on focus
          },
          "& .MuiInputBase-input": {
            padding: "8px 12px", // Increased padding for better touch targets
            fontSize: "14px",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px !important",
          color: "#666",
          "&.Mui-focused": {
            color: "#2DB0E4",
          },
        },
        shrink: {
          fontSize: "14px !important",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "20px", // Larger title for emphasis
          fontWeight: 700, // Bolder title

          paddingBottom: "12px",
          color: "#333", // Darker text for contrast
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "20px 24px", // Increased padding for breathing room
          "& .MuiGrid-container": {
            rowGap: "16px", // Consistent spacing between rows
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "12px 24px",
          justifyContent: "flex-end",
          "& .MuiButton-root": {
            minWidth: "100px", // Consistent button width
            marginLeft: "10px", // Spacing between buttons
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Rounded buttons
          fontSize: "14px",
          textTransform: "none",
          padding: "8px 16px", // Larger padding for better click area
        },
        containedPrimary: {
          backgroundColor: "#2DB0E4", // Brand-specific blue
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1D87B0", // Darker shade on hover
          },
        },
        outlined: {
          color: "#2DB0E4", // Match brand color
          borderColor: "#2DB0E4",
          "&:hover": {
            backgroundColor: "rgba(45,176,228,0.1)", // Subtle hover effect
            borderColor: "#1D87B0",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "12px", // Rounded dialog corners
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // Subtle shadow
          background: "linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%)", // Gradient background
        },
      },
    },
  },
});

export default FormThemes;
